// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2-TuQ","title":"Images45_title__3CfwI","images":"Images45_images__yVAoZ"};